<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      app
    >

      <v-list-item class="profile-data">
        <v-list-item-title v-if="user">
          {{authUserName}}<br />
          <small>{{user.user_type_name}}</small>
          <div class="company-name" v-html="myCompany.name">
          </div>
          <div class="company-business-unit" v-if="myCompany.company_type === 1">
            <v-btn
              v-if="currentBusinessUnit && companyHasMultipleBusinessUnits"
              color="#0F998E"
              dark
              @click.stop="businessUnitPicker = true"
            >
              {{currentBusinessUnitNameEllipsis}}
            </v-btn>
            <div
              class="businessUnitText"
              v-if="currentBusinessUnit && !companyHasMultipleBusinessUnits"
            >
              {{currentBusinessUnitNameEllipsis}}
            </div>
          </div>

        </v-list-item-title>
      </v-list-item>

      <v-list dense>
        <v-list-item :to="{name: 'EndIdentity'}" exact v-if="fakeId">
          <v-list-item-action>
            <v-icon>mdi-account-arrow-right-outline</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Končaj prevzem identitete</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-divider></v-divider>

      <v-list dense>

        <component
          v-for="item of menuItems.filter(item => !!item && item.permission)"
          :key="item.title"
          :itemData="item"
          :itemDisabled="!item.permission"
          :is="item.subItems ? 'TheNavBarListGroupItem' : 'TheNavBarListItem'"
        >
        </component>

      </v-list>

      <v-divider></v-divider>

      <v-list dense>
        <v-list-item :to="{name: 'Logout'}" exact>
          <v-list-item-action>
            <v-icon>mdi-logout-variant</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Odjava</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

    </v-navigation-drawer>

    <v-app-bar app class="header" :class="{'test-mode': isTestBuild}" dark>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title>Hitri Račun <b style="color: red;" v-if="isTestBuild">- (TESTNA VERZIJA)</b></v-toolbar-title>
      <!-- <div>{{}}</div> -->
    </v-app-bar>

    <PopupPickerBusinessUnit
      v-model="businessUnitPicker"
    />
  </div>
</template>

<script>
import TheNavBarListItem from './TheNavBarListItem'
import TheNavBarListGroupItem from './TheNavBarListGroupItem'
import PopupPickerBusinessUnit from './PopupPickerBusinessUnit'
import { mapGetters, mapActions } from 'vuex'
import myCompany from '../router/modules/myCompany'

export default {
  components: {
    TheNavBarListItem,
    TheNavBarListGroupItem,
    PopupPickerBusinessUnit
  },
  data () {
    return {
      drawer: true,
      businessUnitPicker: false,
    }
  },
  computed: {
    ...mapGetters('auth', ['user']),
    ...mapGetters('businessUnits', ['companyHasMultipleBusinessUnits']),
    appropriateUserCmsPermissions () {
      const userSettings = Object.values(this.userTypes).find(typ => typ.id === this.user.user_type)
      if (userSettings && userSettings.settings) {
        return userSettings.settings.filter(setting => setting.relevance === 1)
      }
      return []
    },
    authUserName () {
      return this.user.complete_name
    },
    userTypes () {
      return this.$store.state.userTypes.items
    },
    superadminItems () {
      return [
        {
          title: 'Domov',
          icon: 'mdi-home-city',
          route: 'Home',
          permission: true
        }, {
          title: 'Stranke',
          icon: 'mdi-coffee-outline',
          route: 'Clients',
          permission: true,
        }, {
          title: 'Aktivne blagajne',
          icon: 'mdi-file-excel',
          route: 'ActiveCashRegisters',
          permission: true,
        }, {
          title: 'Distributerji',
          icon: 'mdi-account-supervisor',
          route: 'Distributors',
          permission: true,
        }, {
          title: 'Uporabniki',
          icon: 'mdi-account-group',
          route: 'Users',
          permission: true
        }, /* {
          title: 'Nastavitve',
          icon: 'mdi-account-cog',
          subItems: [
            {
              title: 'Delovni čas',
              route: 'uredidc'
            }
          ]
        } , */ {
          title: 'Moje podjetje',
          icon: 'mdi-factory',
          permission: true,
          subItems: [
            {
              title: 'Izkaznica',
              route: 'MyCompany',
              permission: true,
            }
          ]
        }
      ]
    },
    distributersItems () {
      return [
        {
          title: 'Domov',
          icon: 'mdi-home-city',
          route: 'Home',
          // permission: this.permissionCheck('permission_cms_home')
          permission: true
        }, {
          title: 'Stranke',
          icon: 'mdi-coffee-outline',
          route: 'Clients',
          permission: true
        }, {
          title: 'Aktivne blagajne',
          icon: 'mdi-file-excel',
          route: 'ActiveCashRegisters',
          permission: true
        }, {
          title: 'Uporabniki',
          icon: 'mdi-account-group',
          route: 'Users',
          // permission: this.permissionCheck('permission_cms_users')
          permission: true
        }, /* {
          title: 'Nastavitve',
          icon: 'mdi-account-cog',
          subItems: []
        } */ {
          title: 'Moje podjetje',
          icon: 'mdi-factory',
          permission: true,
          subItems: [
            {
              title: 'Izkaznica',
              route: 'MyCompany',
              permission: true
            }
          ]
        }
      ]
    },
    clientItems () {
      return [
        {
          title: 'Domov',
          icon: 'mdi-home-city',
          route: 'MyCompanyHome',
          permission: this.permissionCheck('permission_cms_home')
        }, {
          title: 'Zadnji računi',
          icon: 'mdi-history',
          color: '#72D2EF',
          route: 'MyCompanyInvoiceHistory',
          permission: this.permissionCheck('permission_cms_invoice_history')
        }, {
          title: 'Zadnja naročila',
          icon: 'mdi-table',
          color: '#0F998E',
          route: 'MyCompanyOrderHistory',
          permission: this.permissionCheck('permission_cms_ordering_history')
        }, {
          title: 'Zbirna naročila',
          icon: 'mdi-format-list-bulleted',
          color: '#000',
          route: 'MyCompanyType1OrderHistory',
          permission: this.permissionCheck('permission_cms_ordering_history')
        }, {
          title: 'Izpisi',
          icon: 'mdi-file-chart-outline',
          color: '#72D2EF!important',
          permission: this.permissionCheck('permission_cms_logs'),
          // permission: true,
          subItems: [
            {
              title: 'Dnevnik prodaje',
              route: 'MyCompanyReportsDaily',
              permission: this.permissionCheck('permission_cms_sales_log')
            }, {
              title: 'Promet prodajalca',
              route: 'MyCompanyReportsUsers',
              permission: this.permissionCheck('permission_cms_salesman_log')
            }, {
              title: 'Promet po artiklih',
              route: 'MyCompanyReportsArticles',
              permission: this.permissionCheck('permission_cms_articles_log')
            }, {
              title: 'Seznam računov',
              route: 'MyCompanyReportsInvoices',
              permission: this.permissionCheck('permission_allow_print_invoices_report')
            }, {
              title: 'Delovni čas',
              route: 'ArhivDelovnegaCasa',
              permission: this.permissionCheck('permission_cms_worktime_log')
            }, {
              title: 'Kontrolni trak',
              route: 'MyCompanyControlTape',
              permission: this.permissionCheck('permission_cms_controltape_log')
            } /*  {
              title: 'Promet zaprtih miz',
              route: 'MyCompanyReportsClosedTables'
            }, */
          ]
        }, {
          title: 'Artikli',
          icon: 'mdi-coffee',
          color: '#ebaa66',
          route: 'MyCompanyArticles',
          permission: this.permissionCheck('permission_cms_articles')
        }, {
          title: 'Uporabniki',
          icon: 'mdi-account-group',
          color: 'blue',
          route: 'MyCompanyUsers',
          permission: this.permissionCheck('permission_cms_users')
        }, {
          title: 'Klienti',
          icon: 'mdi-account-cash',
          color: '#2f89f0',
          route: 'MyCompanyClients',
          permission: this.permissionCheck('permission_cms_clients')
        }, {
          title: 'Ostali šifranti',
          color: '#cc8ed0!important',
          icon: 'mdi-layers-triple-outline',
          permission: this.permissionCheck('permission_cms_other_enums'),
          subItems: [
            {
              title: 'Skupine',
              route: 'MyCompanyCategories',
              permission: this.permissionCheck('permission_cms_other_enums_groups')
            }, {
              title: 'Nivoji',
              route: 'MyCompanyLevels',
              permission: this.permissionCheck('permission_cms_other_enums_levels')
            }, {
              title: 'Prostori',
              route: 'MyCompanyLocations',
              permission: this.permissionCheck('permission_cms_other_enums_places')
            }, {
              title: 'Mize',
              route: 'MyCompanyTables',
              permission: this.permissionCheck('permission_cms_other_enums_tables')
            }, {
              title: 'Lokacije tiskalnikov',
              route: 'MyCompanyPrintersLocations',
              permission: this.permissionCheck('permission_cms_other_enums_print_locations')
            }, {
              title: 'Grupe',
              route: 'MyCompanyGroups',
              permission: this.permissionCheck('permission_cms_other_enums_groups_main')
            }, {
              title: 'Pravice uporabnikov',
              route: 'MyCompanyUserTypes',
              permission: this.permissionCheck('permission_cms_other_enums_user_permissions') || this.user && this.user.user_type_name.toLowerCase() === 'administrator'
            }, {
              title: 'Tipi plačila',
              route: 'MyCompanyPaymentTypes',
              permission: this.permissionCheck('permission_cms_other_enums_payment_types')
            }, {
              title: 'Opombe',
              route: 'MyCompanyComments',
              permission: this.permissionCheck('permission_cms_other_enums_comments')
            }, {
              title: 'Nivoji cen',
              route: 'MyCompanyBusinessUnitPricing',
              permission: this.permissionCheck('permission_cms_other_enums_price_levels')
            }
          ]
        }, {
          title: 'Materialno poslovanje',
          icon: 'mdi-newspaper-variant-outline',
          color: '#9d7272!important',
          permission: this.permissionCheck('permission_cms_material_management'),
          subItems: [
            {
              title: 'Trenutna zaloga',
              route: 'MyCompanyCurrentStock',
              permission: this.permissionCheck('permission_cms_material_management_current_stock')
            }, {
              title: 'Prevzemnice',
              route: 'MyCompanyAcceptanceForms',
              permission: this.permissionCheck('permission_cms_material_management_acceptance_form'),
            }, {
              title: 'Odpis',
              route: 'MyCompanyWriteoffForms',
              permission: this.permissionCheck('permission_cms_material_management_writeoff_forms')
            }, {
              title: 'Inventura',
              route: 'MyCompanyInventoryForms',
              permission: this.permissionCheck('permission_cms_material_management_inventory_forms')
            }, {
              title: 'Analitika',
              route: 'MyCompanyMaterialDiaryList',
              permission: this.permissionCheck('permission_cms_material_management_analytics_forms')
            }
          ]
        }, {
          title: 'Nastavitve',
          icon: 'mdi-account-cog',
          color: '#ef8572!important',
          permission: true,
          subItems: [
            {
              title: 'Moduli blagajn',
              route: 'uredidc',
              permission: true,
            }
          ]
        }, {
          title: 'Moje podjetje',
          icon: 'mdi-factory',
          permission: true,
          subItems: [
            {
              title: 'Izkaznica',
              route: 'MyCompany',
              permission: true,
            }
          ]
        }
      ]
    },
    fakeId () {
      return this.$store.state.auth.masterJwt !== null
    },
    myCompany () {
      return this.$store.state.companies.myCompany
    },
    currentBusinessUnit () {
      return this.$store.state.businessUnits.currentBusinessUnit
    },
    currentBusinessUnitNameEllipsis () {
      if (this.currentBusinessUnit.name.length < 21) {
        return this.currentBusinessUnit.name
      }
      return `${this.currentBusinessUnit.name.substring(0, 18)}...`
    },
    menuItems () {
      if (this.myCompany && this.myCompany.is_top_dealer) return this.superadminItems
      if (this.myCompany && this.myCompany.company_type === 2) return this.distributersItems
      return this.clientItems
    },
    isTestBuild () {
      return process.env.VUE_APP_MODE === 'test'
    }
  },
  methods: {
    ...mapActions('userTypes', ['loadItems']),
    hideDrawerOnMobileDevices () {
      this.drawer = !this.$vuetify.breakpoint.smAndDown
    },
    permissionCheck (permission_key) {
      if (this.appropriateUserCmsPermissions && this.appropriateUserCmsPermissions.length) {
        const found_permission = this.appropriateUserCmsPermissions.find(per => per.key === permission_key)
        if (found_permission) {
          return found_permission.value === 'true'
        }
      }
      return false
    }
  },
  created () {
    this.hideDrawerOnMobileDevices()
    this.loadItems()
  }
}
</script>

<style lang="scss" scoped>
$hr-dark-green: #0F998E;
$hr-light-green: #6FC171;

.header {
  background-image: linear-gradient(to right, #464856 , #464856);
  &.test-mode {
    background-image: linear-gradient(to right, $hr-dark-green , $hr-light-green);
  }
}
.businessUnitText {
  display: inline-block;
  color: white;
  background-color: $hr-dark-green;
  padding: 7px 14px;
  border-radius: 5px;
  text-transform: uppercase;
  font-size: 15px;
}
</style>

<style lang="scss" scoped>
.profile-data {
  text-align: center;
  padding: 20px 0;

  .company-name {
    padding: 10px 0;
    white-space: initial;
  }
  .company-business-unit {
    white-space: initial;
  }
}
</style>
